import {
  Component,
  OnInit,
} from '@angular/core';
import { Constant } from '../../../pages/general/blog/constant';
import { TranslateModule } from '@ngx-translate/core';
import { PortalImagePipe } from '../../pipe/portal-image-standalone.pipe';

@Component({
  standalone: true,
  selector: 'fmarket-footer',
  imports: [TranslateModule, PortalImagePipe],
  templateUrl: './footer.component.html',
  styleUrls: ['footer.scss'],
})
export class FooterComponent implements OnInit {
  theme: any = {};
  language: string = 'VI';
  languageText: string = 'Tiếng Việt';
  Constant = Constant;
  constructor() {}
  ngOnInit() {}
}
